import type { ChainId } from '@cronos-app/sdk';
import { useDesiredChain } from '@cronos-app/wallet';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';

import { TOKEN_CONFIG_MAP } from './tokenConfig';

export { TOKEN_CONFIG_MAP } from './tokenConfig';
export { Token, type TokenConfig } from './types';

export const useNormalTokenConfig = (chainId?: ChainId) => {
  const chainLayer = useGlobalChainLayer();
  const desiredChain = useDesiredChain(chainLayer);
  return TOKEN_CONFIG_MAP[chainId ?? desiredChain];
};
